var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"my-3 my-lg-0",on:{"submit":function($event){$event.preventDefault();return _vm.emitSubmit.apply(null, arguments)}}},[_c('autocomplete',{attrs:{"route":_vm.route},on:{"selected":_vm.emitSubmit},model:{value:(_vm.q),callback:function ($$v) {_vm.q=$$v},expression:"q"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }